import { useLazyQuery, useQuery } from "@apollo/client";
import {
  UserSitesQuery,
  UserSitesQueryVariables,
} from "../../../__generated__/UserSitesQuery";
import { USER_SITES } from "../user-sites.queries";

export const useUserSites = (variables: UserSitesQueryVariables) => {
  return useQuery<UserSitesQuery, UserSitesQueryVariables>(USER_SITES, {
    variables,
  });
};

export const useLazyUserSites = () => {
  return useLazyQuery<UserSitesQuery>(USER_SITES);
};
